import React, { useEffect } from 'react';

import PropTypes from 'prop-types';
import { TextInput } from '@telus-uds/components-web';
import _ from 'lodash';

import { channelOutletMapping } from '../../../../../utils/constant';
import { outletIdStoreCodeMapping } from '../../../../../registration/constant';

const Outlet = ({ fieldData, setFieldData, formErrors, setFormErrors }) => {
  useEffect(() => {
    return () => {
      setFieldData(previousValue => ({ ...previousValue, outlet: '' }));
    };
  }, []);

  const getMappedStoreCode = outletId => {
    return outletIdStoreCodeMapping[outletId] || null;
  };

  return (
    <TextInput
      type="tel"
      label="Outlet ID *"
      pattern="[0-9]{10}"
      maxLength="10"
      value={fieldData.outlet}
      error={'outlet' in formErrors ? formErrors.outlet.message : undefined}
      onChange={(value) => {
        const channelOutletMappingResult = Object.keys(
          channelOutletMapping
        ).filter(channel =>
          _.get(channelOutletMapping, channel, []).includes(value)
        );
        const mappedStoreCode = getMappedStoreCode(value);

        if (!value)
          setFormErrors({
            ...formErrors,
            outlet: { message: 'Field is required' }
          });
        else if (!/^[0-9]{10}/.test(value)) {
          setFormErrors({
            ...formErrors,
            outlet: { message: 'Outlet Id must be exactly 10 digit' }
          });
        } else {
          const errors = { ...formErrors };
          delete errors.outlet;
          setFormErrors({
            ...errors
          });
        }
        setFieldData(previousValue => ({
          ...previousValue,
          outlet: value,
          ...(channelOutletMappingResult.length
            ? { channels: channelOutletMappingResult }
            : {}),
          ...(mappedStoreCode ? { storeCode: mappedStoreCode } : {})
        }));
      }}
    />
  );
};

Outlet.propTypes = {
  formErrors: PropTypes.shape({
    outlet: PropTypes.shape({
      message: PropTypes.string
    })
  }).isRequired,
  setFormErrors: PropTypes.func.isRequired,
  setFieldData: PropTypes.func.isRequired,
  fieldData: PropTypes.shape({
    role: PropTypes.number,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    email: PropTypes.string,
    contactNumber: PropTypes.string,
    provinces: PropTypes.arrayOf(PropTypes.string),
    channels: PropTypes.arrayOf(PropTypes.string),
    outlet: PropTypes.string,
    cpmsId: PropTypes.string,
    xid: PropTypes.string,
    storeCode: PropTypes.string,
    dealership: PropTypes.arrayOf(PropTypes.string),
    channelOrgCode: PropTypes.string,
    salesManager: PropTypes.string,
    salesManagerEmail: PropTypes.string
  }).isRequired
};

export default Outlet;
